import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useScreen } from '../lib/useScreen';

const font = "'DM Sans', sans-serif";
const serif = "'DM Serif Display', serif";
const C = { turquesa:'#5dc1b9', logoGrad:'linear-gradient(135deg, #534AB7, #1D9E75)' };

export default function Terminos() {
  const navigate = useNavigate();
  const { isMobile } = useScreen();
  const s = { fontSize:14, color:'rgba(255,255,255,0.65)', lineHeight:1.8, margin:'0 0 16px' };
  const h = { fontFamily:serif, fontSize:18, fontWeight:400, color:'#fff', margin:'28px 0 10px' };
  const li = { ...s, margin:'0 0 6px' };

  return (
    <div style={{ minHeight:'100vh', background:'#0a0a0a', color:'#fff', fontFamily:font }}>
      <nav style={{ maxWidth:720, margin:'0 auto', padding:isMobile?'1rem':'1.2rem 1.5rem', display:'flex', alignItems:'center', justifyContent:'space-between' }}>
        <div onClick={() => navigate('/')} style={{ display:'flex', alignItems:'center', gap:10, cursor:'pointer' }}>
          <div style={{ width:32, height:32, borderRadius:'50%', background:C.logoGrad, display:'flex', alignItems:'center', justifyContent:'center' }}><span style={{ color:'#fff', fontSize:10, fontWeight:600 }}>T&D</span></div>
          <span style={{ fontSize:14, fontWeight:500 }}>Thinker & Doer</span>
        </div>
        <span onClick={() => navigate('/')} style={{ fontSize:13, color:'rgba(255,255,255,0.5)', cursor:'pointer' }}>← Inicio</span>
      </nav>

      <main style={{ maxWidth:720, margin:'0 auto', padding:isMobile?'2rem 1rem 4rem':'3rem 1.5rem 5rem' }}>
        <h1 style={{ fontFamily:serif, fontSize:isMobile?24:32, fontWeight:400, margin:'0 0 8px' }}>Términos y Condiciones</h1>
        <p style={{ fontSize:12, color:'rgba(255,255,255,0.3)', margin:'0 0 32px' }}>Última actualización: julio 2026</p>

        <div style={{ background:'rgba(255,255,255,0.04)', border:'1px solid rgba(255,255,255,0.08)', borderRadius:20, padding:isMobile?'24px 20px':'32px 28px' }}>
          <h2 style={h}>1. Quiénes somos</h2>
          <p style={s}>Thinker & Doer (T&D) es una plataforma en línea para emprendedores, operada desde México, accesible en thinkeranddoer.com. Contacto: <strong style={{color:'#fff'}}>thinkanddo.er@gmail.com</strong>.</p>

          <h2 style={h}>2. El servicio</h2>
          <p style={s}>T&D ofrece: un gestor de información personal para tus ideas, una red de emprendedores (La Sala), programas y cursos (como Tu Radar), y membresías de pago. También ofrecemos Onsite Growth México, un servicio presencial que se cotiza por separado vía WhatsApp.</p>

          <h2 style={h}>3. Tu cuenta</h2>
          <ul style={{ ...s, paddingLeft:20 }}>
            <li style={li}>Necesitas iniciar sesión con Google y tener al menos 18 años.</li>
            <li style={li}>Eres responsable de la actividad en tu cuenta y de la información que publicas.</li>
            <li style={li}>Podemos suspender cuentas que hagan mal uso de la plataforma (spam, acoso, contenido ilegal o que dañe a otros usuarios).</li>
          </ul>

          <h2 style={h}>4. Membresías y pagos</h2>
          <ul style={{ ...s, paddingLeft:20 }}>
            <li style={li}><strong style={{color:'#fff'}}>Free Observer</strong>: gratis.</li>
            <li style={li}><strong style={{color:'#fff'}}>Tu Radar</strong>: pago único de $599 MXN; acceso al curso de 30 días y acceso Free permanente después.</li>
            <li style={li}><strong style={{color:'#fff'}}>Doer</strong>: suscripción mensual de $139 MXN que se renueva automáticamente cada mes. Incluye 7 días de prueba gratis.</li>
            <li style={li}>Los pagos se procesan de forma segura a través de Stripe. T&D no almacena los datos de tu tarjeta.</li>
            <li style={li}>Los precios pueden cambiar; si cambia el de tu suscripción, te avisaremos antes de tu siguiente cobro.</li>
          </ul>

          <h2 style={h}>5. Cancelaciones y reembolsos</h2>
          <ul style={{ ...s, paddingLeft:20 }}>
            <li style={li}>Puedes cancelar tu suscripción en cualquier momento; conservas el acceso hasta el final del periodo ya pagado.</li>
            <li style={li}>Los pagos únicos (como Tu Radar) tienen garantía de 14 días: si no te convence, escríbenos y te devolvemos tu dinero.</li>
            <li style={li}>Las suscripciones mensuales no son reembolsables por meses ya iniciados.</li>
          </ul>

          <h2 style={h}>6. Tu contenido</h2>
          <ul style={{ ...s, paddingLeft:20 }}>
            <li style={li}>Las ideas y notas que escribes son tuyas. T&D no reclama propiedad sobre tu contenido.</li>
            <li style={li}>Lo que marques como <strong style={{color:'#fff'}}>privado</strong> solo lo ves tú. Lo que publiques como <strong style={{color:'#fff'}}>público</strong> será visible para la comunidad.</li>
            <li style={li}>Al publicar contenido público nos das permiso de mostrarlo dentro de la plataforma.</li>
          </ul>

          <h2 style={h}>7. Uso de inteligencia artificial</h2>
          <p style={s}>Genio y Luca son asistentes de IA. Sus respuestas son orientación, no asesoría profesional (legal, financiera o médica). Las decisiones sobre tu negocio son tuyas.</p>

          <h2 style={h}>8. Límites de responsabilidad</h2>
          <p style={s}>T&D se ofrece "tal cual". No garantizamos resultados de negocio ni disponibilidad ininterrumpida del servicio. No somos responsables de acuerdos o tratos entre usuarios que se conozcan a través de la plataforma.</p>

          <h2 style={h}>9. Cambios a estos términos</h2>
          <p style={s}>Podemos actualizar estos términos. Si el cambio es importante, lo avisaremos en la plataforma. Usar T&D después de un cambio significa que lo aceptas.</p>
        </div>
      </main>
    </div>
  );
}
